<!--
 * @Author: maqian maqian@aeonmed.com
 * @Date: 2023-12-25 16:39:26
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-02-28 16:24:17
 * @FilePath: \shh-download\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  padding: 0;
  margin: 0;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue